import React, { useState } from 'react';
import { ListChecks, Route, KanbanSquare } from 'lucide-react';
import { AtlasUser } from '../shared/atlasApi';
import Trilhas from './Trilhas';
import Execucoes from './Execucoes';

interface Props {
  user: AtlasUser;
  podeEditar: boolean;
}

type SubView = 'trilhas' | 'execucoes';

const TABS: { id: SubView; label: string; icon: React.ReactNode }[] = [
  { id: 'execucoes', label: 'Execuções', icon: <KanbanSquare className="w-4 h-4" /> },
  { id: 'trilhas', label: 'Trilhas', icon: <Route className="w-4 h-4" /> },
];

const OnboardingApp: React.FC<Props> = ({ user, podeEditar }) => {
  const [subview, setSubview] = useState<SubView>('execucoes');

  return (
    <div className="p-6 space-y-4 max-w-5xl">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="w-10 h-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center"><ListChecks className="w-5 h-5" /></div>
        <div className="flex-1">
          <h2 className="text-lg font-bold text-gray-900">Onboarding</h2>
          <p className="text-sm text-gray-500">Trilhas de integração e acompanhamento de novos colaboradores.</p>
        </div>
      </div>

      <div className="flex gap-1 border-b border-gray-200">
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setSubview(t.id)}
            className={`px-4 py-2 text-sm font-medium flex items-center gap-2 border-b-2 -mb-px transition ${
              subview === t.id ? 'border-purple-600 text-purple-700' : 'border-transparent text-gray-500 hover:text-gray-800'
            }`}
          >
            {t.icon}{t.label}
          </button>
        ))}
      </div>

      {subview === 'trilhas' ? (
        <Trilhas user={user} podeEditar={podeEditar} />
      ) : (
        <Execucoes user={user} podeEditar={podeEditar} />
      )}
    </div>
  );
};

export default OnboardingApp;
